// src/components/common/ToastSystem.jsx

import React, { useEffect, useRef, useState, useCallback } from "react";
import { createPortal } from "react-dom";

// Função auxiliar para gerar chave única (copiada do Header.jsx)
function makeKey(alert) {
return btoa(unescape(encodeURIComponent(`${alert.message}|${alert.action}`)));
}

// Usando export default para evitar o erro de importação nomeada em App.js
export default function ToastSystem() {
const [toasts, setToasts] = useState([]);
const counter = useRef(0);

    const removeToast = useCallback((id) => {
 setToasts((prev) => prev.filter((t) => t.id !== id));
}, []);

// ============================================================
// REGISTRA window.showToast (global)
// ============================================================
useEffect(() => {
 window.showToast = ({
title = "",
message = "",
variant = "info",
duration = 6000,
persistent = false, 
meta = null,
onAction = null,
 }) => {
            // 1. GERA CHAVE BASEADA NA MENSAGEM PARA IDENTIFICAR DUPLICIDADE
            const alertKey = makeKey({ message, action: meta?.action || '' });
            
            // 2. VERIFICA SE O TOAST PERSISTENTE JÁ ESTÁ ATIVO
            // Se for persistente E já houver um toast com a mesma chave, não adiciona.
            if (persistent) {
                const isDuplicate = toasts.some(t => t.alertKey === alertKey && t.persistent);
                if (isDuplicate) {
                    // console.log("Toast persistente duplicado bloqueado:", message);
                    return; 
                }
            }

const id = counter.current++;

const toast = {
id,
title,
message,
variant,
persistent,
meta,
onAction,
                alertKey, // Guarda a chave para futuras verificações
};

setToasts((prev) => [...prev, toast]);

// AUTO-HIDE somente se NÃO for persistente
if (!persistent) {
setTimeout(() => {
removeToast(id);
}, duration);
}
 };

 return () => {
window.showToast = null;
 };
    // Adicionamos toasts como dependência para que a função showToast
    // possa acessar a lista atual de toasts (se o useEffect for reexecutado)
}, [toasts, removeToast]); 


return createPortal(
 <div id="toast-container">
{toasts.map((toast) => (
<div
key={toast.id}
// Aplica auto-hide SE NÃO for persistente.
className={`toast ${!toast.persistent ? "auto-hide" : ""} ${toast.variant}`}
// Estilo para garantir que toasts persistentes não tenham a animação de saída.
style={toast.persistent ? { animation: 'toast-in .5s cubic-bezier(0.2, 0.8, 0.2, 1.1) forwards' } : {}}
>
                    {/* Botão de fechar canto superior direito para todos os toasts */}
                    <button
className="absolute top-2 right-3 text-xl font-bold text-white opacity-50 hover:opacity-100 transition"
onClick={() => removeToast(toast.id)}
>
✕
</button>

<div>
{toast.title && (
<p className="font-bold text-base mb-1">{toast.title}</p>
)}
<p className="text-sm opacity-90">{toast.message}</p>
</div>

{/* AÇÕES */}
{(toast.meta?.action || toast.onAction) && (
<div className="toast-actions">
{/* O botão close '✕' já está no canto. Usamos 'Ignorar' aqui se necessário */}
                            {toast.persistent && (
                                <button
                                    className="toast-btn close"
                                    onClick={() => removeToast(toast.id)}
                                >
                                    Ignorar
                                </button>
                            )}

<button
 className="toast-btn action"
 onClick={() => toast.onAction?.()}
>
 {toast.meta?.actionText || "Resolver"}
</button>
</div>
)}
</div>
))}
 </div>,
 document.body
);
}